import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Loader } from '../../../../../common/elements';
import { NetworkHelpers as Network } from '../../../../../../helpers/';
import { DisplayModule, ModuleVideoSlider } from './elements';
import * as coursesActions from '../../../../../../actions/training/courses/courses';

class CourseItemFull extends Component {

    componentDidMount() {
        const { courseId } = this.props.params;
        const { getCurrentCourse, getCurrentCourseModules } = this.props;

        getCurrentCourse( courseId );
        getCurrentCourseModules( courseId );
    };

  render() {

    const {course, modules, params} = this.props;

    if (course && modules) {

      const module = Object.keys(modules).filter(module => parseInt(modules[module].id, 10) === parseInt(params.moduleId, 10));
      const numOfModules = Object.keys(modules);
      const thisModule = modules[module];

      return (
        <article className="module-body">
          <main className="container">
            <DisplayModule module={ thisModule } courseName={ course.name }/>
            { modules.length > 0 ?
              <ModuleVideoSlider numOfModules={numOfModules} modules={ modules } params={ params } courseName={ course.name }/>
              :
              null
            }
          </main>
          <aside>
          </aside>
        </article>
      );
    }

    return <Loader />;
  }
}

const mapStateToProps = (state) => {

  return {
    course: state.courses.current_course,
    modules: state.courses.current_course_modules
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCurrentCourse: (courseId) => dispatch(coursesActions.getCurrentCourse(courseId)),
    getCurrentCourseModules: (courseId) => dispatch(coursesActions.getCurrentCourseModules(courseId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CourseItemFull);



// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/CourseModuleView.js